import { ApiService } from "./ApiService.js";
import { LoginService } from "./LoginService.js";
import { ServiceConsts } from "./ServiceConsts.js";

export class GiftService {
    static async getGifts() {
        return ApiService.get(`${ServiceConsts.API_URL}/gifts`);
    }

    static async sendGift(gift) {
        return ApiService.post(`${ServiceConsts.API_URL}/gifts`, gift);
    }
}
